import { defineNuxtPlugin, ElNotification } from '#imports';

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.use(ElNotification);
})
